<template>
    <MainContent title="Dashboard">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                <h3 class="card-title pt-2 mb-0">Dashboard campañas</h3>
                <div class="card-tools">
                    <router-link
                        :to="{ name: 'back.emails.boletines.crear' }"
                        class="btn btn-primary"
                    >
                        CREAR BOLETÍN
                    </router-link>
                </div>
            </div>
        </template>

        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                    <Resumen 
                        :datos-resumen="datosResumen"
                        :loading="loadingResumen"
                        @date-range-changed="onResumenDateRangeChange"
                    />
                </b-col>
                <b-col sm="12" md="8" lg="8">
                    <EstadisticasGenerales 
                        :datos-estadisticas="datosEstadisticas"
                        :loading="loading"
                        @date-range-changed="onDateRangeChange"
                    />
                </b-col>
                <b-col sm="12" md="4" lg="4">
                    <UltimosBoletines />
                </b-col>
                <b-col cols="12">
                    <ActividadReciente 
                        :datos-actividad = "datosActividad"
                        :loading = "loadingActividad"
                    />
                </b-col>                    
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import Resumen from "@/components/backend/campana-emails/dashboard/Resumen";
    import UltimosBoletines from "@/components/backend/campana-emails/dashboard/UltimosBoletines";
    import ActividadReciente from "@/components/backend/campana-emails/dashboard/ActividadReciente";
    import EstadisticasGenerales from "@/components/backend/components/dashboardComponents/EstadisticasGenerales.vue";
    import apiService from "@/services/api-comunicados";

    export default {
        
        components: {
            MainContent,
            Resumen,
            ActividadReciente,
            UltimosBoletines,
            EstadisticasGenerales,
        },
        
        data() {
            return {
                loading: false,
                loadingResumen: false,
                loadingActividad: false,
                datosEstadisticas: {},
                datosResumen: {},
                datosActividad: [],
                initialMount: true,
            };
        },
        methods:{
            async onDateRangeChange({ startDate, endDate }) {
                if (this.initialMount) return;

                await this.getEstadisticas(startDate, endDate);
            },

            async onResumenDateRangeChange({ startDate, endDate }) {
                if (this.initialMount) return;

                await this.getResumen(startDate, endDate);

            },

            async getEstadisticas(fechaDesde, fechaHasta) {
                const fechas = {
                    fecha_inicio: fechaDesde,
                    fecha_fin: fechaHasta,
                };

                try {
                    this.loading = true;
                    this.datosEstadisticas = await apiService.getEstadisticasGenerales(fechas);
                }
                catch (error) {
                    this.$toast.error("Error al cargar los datos. Por favor, inténtelo más tarde.");
                }
                finally {
                    this.loading = false;
                }
            },

            async getResumen( startDate, endDate ) {
                this.loadingResumen = true;
                try {
                    const response = await apiService.getResumen({ fecha_inicio: startDate, fecha_fin: endDate });
                    this.datosResumen = response.data;
                } finally {
                    this.loadingResumen = false;
                }
            },

            async getActividadesRecientes() {
                this.loadingActividad = true;

                try {
                    const response = await apiService.getActividadReciente();
                    this.datosActividad = response.data;
                } catch (error) {
                    console.error('Error al obtener las actividades recientes', error);
                } finally {
                    this.loadingActividad = false;
                    this.initialMount = false;
                }
            }
        },
        created(){
            const hoy = new Date();
            const desde = new Date(hoy);
            desde.setDate(hoy.getDate() - 6);
            
            const fechaDes = desde.toISOString().substring(0, 10);
            const fechaHasta = hoy.toISOString().substring(0, 10);
            
            this.getEstadisticas(fechaDes, fechaHasta);
            this.getResumen(fechaDes, fechaHasta);
            this.getActividadesRecientes();
        }
    };
</script>
<style scoped>
.container-fluid{
    min-height: 500px;
}
</style>
